import { apiGet, apiPost, apiPut } from './api';

// 用户登录
export const login = (credentials) => {
  return apiPost('/system/auth/login', credentials);
};

// 用户注册
export const register = (userData) => {
  return apiPost('/auth/register', userData);
};

// 获取用户信息
export const getUserInfo = () => {
  return apiGet('/user/info');
};

// 更新用户信息
export const updateUserInfo = (userData) => {
  return apiPut('/user/update', userData);
};
